__turbopack_context__.v({
  "Black": "KX0d8G_Black",
  "Icon": "KX0d8G_Icon",
});
